/* eslint-disable react/no-unescaped-entities */

"use client";

import Link from "next/link";
import { useEffect } from "react";
import { motion } from "motion/react";

import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";

import styles from "./state.module.css";

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <SiteHeader />
      <div className={`${styles.screen} ${styles.screenWithSiteChrome}`}>
      <motion.div
        className={styles.card}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.32, ease: "easeOut" }}
      >
        <span className={styles.eyebrow}>
          <i className="bi bi-exclamation-octagon"></i>
          Incident temporaire
        </span>

        <h1 className={styles.title}>Une erreur est survenue pendant le chargement de cette page.</h1>
        <p className={styles.text}>
          Le service n'est peut-être pas disponible momentanément ou une opération n'a pas pu être finalisée.
          Vous pouvez réessayer immédiatement ou revenir à l'accueil.
        </p>

        {error.digest ? <div className={styles.errorCode}>Référence: {error.digest}</div> : null}

        <div className={styles.actions}>
          <button type="button" onClick={reset} className={styles.actionPrimary}>
            Réessayer
          </button>
          <Link href="/" className={styles.actionSecondary}>
            Retour à l'accueil
          </Link>
          <Link href="/nous-contacter" className={styles.actionSecondary}>
            Nous contacter
          </Link>
        </div>
      </motion.div>
    </div>
      <SiteFooter />
    </>
  );
}
